import React from "react";

const ru = {
	main: {
		siteTitle: "Reactfolio — Кодирхон Нодирханов",
	},

	nav: {
		home: "Главная",
		about: "Обо мне",
		projects: "Проекты",
		skills: "Навыки",
		articles: "Статьи",
		contact: "Контакты",
		resume: "Резюме",
		resumeTitle: "Скачать резюме",
	},

	lang: {
		uz: "УЗ",
		en: "EN",
		ru: "RU",
	},

	footer: {
		credits: "© Нодирханов Кодирхан",
	},

	titles: {
		about: "Обо мне",
		projects: "Проекты",
		skills: "Навыки",
		articles: "Статьи",
		contact: "Контакты",
	},

	homepage: {
		title: "Я — Нодирханов Кодирхан.",
		description:
			"Я backend-разработчик с опытом в React.js. Создаю масштабируемые, безопасные и надёжные веб-приложения с использованием различных фреймворков и технологий. Люблю решать сложные задачи и осваивать новые навыки. Стремлюсь к качественному коду, соответствующему лучшим практикам и отраслевым стандартам. Всегда открыт новым вызовам и возможностям для роста.",
	},

	about: {
		title: "Обо мне",
		description: `Привет, я Кодирхон Нодирханов — 18-летний увлечённый веб-разработчик, родился 15 февраля. Специализируюсь на создании современных, адаптивных и динамичных веб-приложений с использованием актуальных технологий.

Владею React.js, JavaScript, Node.js, HTML и CSS; мне нравится воплощать идеи в чистом коде и создавать удобные интерфейсы. Постоянно учусь, развиваюсь и строю цифровые решения, которые упрощают жизнь людей.

Вне кода изучаю новые тренды, участвую в open-source и делюсь знаниями с сообществом. Верю в силу совместной работы и непрерывного обучения в быстро меняющейся сфере.
Если вам нужен ответственный и мотивированный разработчик для проекта — напишите.
Давайте создадим что-то классное вместе!`,
	},

	articlesIntro: {
		title: "Новости из моей жизни.",
		description:
			"Здесь я буду публиковать заметки о событиях в моей жизни в формате статей.",
	},

	projectsPage: {
		title: "Проекты, в которых я пытался оставить след.",
		subtitle: `За годы я работал над разными проектами и горжусь прогрессом. Многие проекты с открытым исходным кодом — их можно изучать и дополнять. Если что-то заинтересует, загляните в код и предложите улучшения. Совместная работа — отличный способ учиться, я открыт для идей и обратной связи.`,
	},

	contact: {
		pageTitle: "Есть идея? Давайте воплотим её вместе.",
		lead:
			"Проект, предложение о сотрудничестве или просто вопрос — неважно, пишите. Я сам читаю каждое сообщение и обязательно отвечаю.",
		available: "Открыт для новых проектов",
		response: "Обычно отвечаю в течение 24 часов",
		cards: {
			email: "Для официальных предложений и сотрудничества",
			telegram: "Самый быстрый способ — здесь отвечаю быстрее всего",
			instagram: "Моя повседневная жизнь и новости",
			github: "Мой код и открытые проекты",
		},
		write: "Написать",
		closing:
			"Лучшие проекты начинаются с простого «привет». Сделайте первый шаг!",
	},

	socials: {
		telegram: "Telegram",
		github: "GitHub",
		instagram: "Instagram",
	},

	works: {
		cardTitle: "Обучение",
		entries: [
			{
				title: "Школа №22, Наманган",
				subtitle: "11 лет",
				duration: "2015 - 2026",
			},
			{
				title: "Start 21, Наманган",
				subtitle: "1 год | английский",
				duration: "2024 - 2025",
			},
			{
				title: "Изучение IT",
				subtitle: "Algoritm",
				duration: "2023 - 2025",
			},
			{
				title: "PDP University",
				subtitle: "Студент",
				duration: "2026 - настоящее время",
			},
		],
	},

	articleLink: "Читать статью",

	projects: [
		{
			title: "Система очередей — Sherdor Medical",
			description:
				"Полноценная система электронной очереди и управления для клиники: киоск, регистратура, касса, лаборатория, приложения для врачей и руководителя. Голосовые объявления на узбекском языке на ТВ в зале ожидания, SMS и Telegram-уведомления для пациентов, проверка результатов анализов по QR-коду. Работает без интернета и автоматически синхронизирует данные с сервером. Написана на Node.js, React, MongoDB, Electron и Android.",
			linkText: "Посмотреть проект",
		},
		{
			title: "Проект 1",
			description:
				"Бот для продажи Telegram Stars с быстрым и понятным сценарием покупки. Пользователь может купить Stars, отслеживать статус заказа и получать оперативную поддержку. Ссылка: @uzbstarsbuybot",
			linkText: "Открыть проект",
		},
		{
			title: "Проект 2",
			description:
				"Полноценный Telegram-бот для продаж: Premium, Stars, gifts и NFT. Разработан на React и PHP. Ссылка на бота: @milliydokonbot",
			linkText: "Открыть проект",
		},
	],

	articles: [
		{
			date: "25.10.2026",
			title: "Navbat: как я построил электронную очередь для клиники.",
			description:
				"От бумажной очереди и шумного зала до киоска, голосовых объявлений на ТВ и приложения для руководителя — как появилась система Navbat…",
			keywords: ["Navbat", "электронная очередь", "клиника", "Qodirkhan"],
			style: "",
			body: (
				<React.Fragment>
					<div className="article-content">
						<div className="paragraph">
							Всё началось с простого наблюдения: пациенты в клинике ждали
							очередь по бумажкам или на словах, споры о том, кто следующий,
							возникали постоянно, а регистратура одновременно и записывала
							пациентов, и управляла очередью. Тогда я решил объединить весь
							рабочий процесс клиники в одну систему — так появилась Navbat.
							<br />
							<br />
							Система состоит из нескольких приложений. Пациент берёт талон
							в киоске или регистрируется в регистратуре. Касса принимает
							оплату, лаборатория вносит результаты анализов, а врач
							вызывает следующего пациента из своего кабинета. На телевизоре
							в зале видны номера очереди, а вызов объявляется голосом на
							узбекском языке — пациенту не нужно не отрываясь смотреть на
							экран.
							<br />
							<br />
							Для пациентов я добавил удобства: уведомления по SMS и в
							Telegram, а результаты анализов можно проверить по QR-коду на
							чеке. Для руководителя клиники написал отдельное
							Android-приложение: дневная выручка, число пациентов, загрузка
							кабинетов и отчёты — из любого места.
							<br />
							<br />
							Технически система работает на сервере Node.js и MongoDB,
							веб-интерфейсах на React, десктопных приложениях на Electron и
							на Android. Этот проект научил меня проектировать не отдельное
							приложение, а целую экосистему, на которую реальные люди
							опираются каждый день.
						</div>
					</div>
				</React.Fragment>
			),
		},
		{
			date: "18.10.2026",
			title: "Система, которая работает без интернета: уроки Navbat.",
			description:
				"Работа клиники не должна останавливаться, даже если интернет пропал на час. Об офлайн-режиме, автообновлении и резервных копиях…",
			keywords: ["Navbat", "офлайн", "резервные копии", "Node.js", "Qodirkhan"],
			style: "",
			body: (
				<React.Fragment>
					<div className="article-content">
						<div className="paragraph">
							Главный урок после запуска Navbat: в клинике отключение
							интернета — вопрос не «если», а «когда». А пациенты ждать не
							будут. Поэтому система в первую очередь работает на локальном
							сервере внутри клиники: регистратура, касса, лаборатория и
							телевизор в зале связаны между собой и без интернета.
							<br />
							<br />
							Когда связь возвращается, данные автоматически
							синхронизируются с облачным сервером. Самое сложное — чтобы ни
							одна запись не потерялась и не записалась дважды. Я добавил
							уникальные идентификаторы для каждого чека и платежа, очередь
							повторных попыток и защиту от дублей на сервере. В системе,
							которая работает с деньгами, даже один потерянный чек —
							большая проблема.
							<br />
							<br />
							Устанавливать новые версии на каждый компьютер вручную было
							невозможно, поэтому я написал механизм автообновления:
							приложения сами скачивают и устанавливают новую версию, а
							данные хранятся отдельно в безопасном месте. Кроме того,
							резервные копии базы данных регулярно отправляются в Telegram
							— даже если с сервером что-то случится, данные можно
							восстановить.
							<br />
							<br />
							Этот опыт показал мне, что главное в программировании — не
							красивый код, а надёжность: система должна работать каждый
							день и в любых условиях. Navbat продолжает развиваться, и
							каждая новая версия улучшается по отзывам реальных
							пользователей.
						</div>
					</div>
				</React.Fragment>
			),
		},
	],

	notFound: {
		title: "Упс!",
		message:
			"Страница не найдена.\nЗапрошенный адрес \"{{url}}\" отсутствует на сервере.",
		link: "На главную",
	},

	skillsPage: {
		title: "Технологии, с которыми я работаю.",
		subtitle: "С помощью этих технологий я создаю веб-приложения целиком — от интерфейса до сервера — и каждый день использую их в реальных проектах, например в системе электронной очереди Navbat.",
		items: {
			html: "Семантическая и доступная структура страниц, чистая SEO-разметка.",
			css: "Адаптивный дизайн, Flexbox и Grid, анимации и современные стили.",
			js: "Основной язык для браузера и сервера: ES6+, асинхронный код, DOM.",
			react: "Быстрые интерфейсы на компонентах, хуках и роутинге.",
			node: "Серверы, сервисы реального времени, фоновые задачи и десктоп-приложения (Electron).",
			express: "REST API, middleware, аутентификация и загрузка файлов.",
			python: "Скрипты автоматизации, Telegram-боты и обработка данных.",
			cpp: "От основ до ООП: классы, наследование, инкапсуляция и полиморфизм.",
		},
	},

	seo: {
		home: {
			description:
				"Backend-разработчик. Опыт создания надёжных приложений на React и современном стеке.",
			keywords: ["Кодирхан", "Нодирханов", "портфолио", "разработчик"],
		},
		about: {
			description:
				"Кодирхон Нодирханов: веб-разработка, React, Node.js и современные приложения.",
			keywords: ["Кодирхан", "портфолио", "обо мне"],
		},
		articles: {
			description:
				"Статьи о разработке, учёбе и событиях.",
			keywords: ["Кодирхан", "статьи", "блог"],
		},
		projects: {
			description:
				"Портфолио проектов и open-source.",
			keywords: ["Кодирхан", "проекты"],
		},
		skills: {
			description:
				"Технологии Кодирхона Нодирхонова: HTML, CSS, JavaScript, React, Node.js, Express.js, Python, C++.",
			keywords: ["Qodirkhan", "навыки", "React", "Node.js", "Python"],
		},
		contact: {
			description:
				"Связь по проектам и сотрудничеству.",
			keywords: ["Кодирхан", "контакты", "email"],
		},
	},
};

export default ru;
